import signatureRequestEn from './signature-request/default';

export default {
  signatureRequest: signatureRequestEn,
};
